<template>
  <page>
    <tabs :activeTab="activeTab" :tabs="tabs" :onTabChange="onTabChange" />
  </page>
</template>

<script>
import Page from "@/components/layout/Page";
import Tabs from "@/components/layout/Tabs";

import Admin from "./Admin/Admin";
import Announcements from "./Announcements/Announcements";
import Experiments from "./Experiments/Experiments";
import Storybook from "./Storybook/Storybook";
import Personalization from "./Personalization/Personalization";
import EducationPosts from "./EducationPosts/EducationPosts";
import VSCodeExtension from "./VSCodeExtension/VSCodeExtension";
import BetaFeatures from './BetaFeatures/BetaFeatures';

export default {
  data() {
    return {
      activeTab: this.$route.params.tab || "announcements",
      tabs: [
        Announcements,
        Admin,
        EducationPosts,
        Experiments,
        Storybook,
        Personalization,
        VSCodeExtension,
        BetaFeatures
      ],
    };
  },
  components: {
    Page,
    Tabs,
  },
  methods: {
    onTabChange(tab) {
      this.$router.push(`/product/${tab.name}`, () => {});
    },
  },
};
</script>
